
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gameSlug]/builds/classes-and-specs",
      function () {
        return require("private-next-pages/[gameSlug]/builds/classes-and-specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gameSlug]/builds/classes-and-specs"])
      });
    }
  